import styled from "styled-components"
import { useEffect, useState } from "react"
import Star5 from "../assets/images/bg_star_5.svg"
import Star4 from "../assets/images/bg_star_4.svg"
import Star3 from "../assets/images/bg_star_3.svg"
import Star2 from "../assets/images/bg_star_2.svg"
import Star1 from "../assets/images/bg_star_1.svg"
import Enforce0 from "../assets/images/ic_enforce_0.svg"
import Enforce1 from "../assets/images/ic_enforce_1.svg"
import Enforce2 from "../assets/images/ic_enforce_2.svg"
import Enforce3 from "../assets/images/ic_enforce_3.svg"
import Enforce4 from "../assets/images/ic_enforce_4.svg"
import Enforce5 from "../assets/images/ic_enforce_5.svg"
import Enforce6 from "../assets/images/ic_enforce_6.svg"
import Enforce7 from "../assets/images/ic_enforce_7.svg"
import Enforce8 from "../assets/images/ic_enforce_8.svg"
import Enforce9 from "../assets/images/ic_enforce_9.svg"
import Enforce10 from "../assets/images/ic_enforce_10.svg"
import Awaken1 from "../assets/images/ic_awaken_1.svg"
import Awaken2 from "../assets/images/ic_awaken_2.svg"
import Awaken3 from "../assets/images/ic_awaken_3.svg"
import Awaken4 from "../assets/images/ic_awaken_4.svg"
import Awaken5 from "../assets/images/ic_awaken_5.svg"
import Awaken6 from "../assets/images/ic_awaken_6.svg"
import Awaken7 from "../assets/images/ic_awaken_7.svg"
import Awaken8 from "../assets/images/ic_awaken_8.svg"
import Awaken9 from "../assets/images/ic_awaken_9.svg"
import {ReactComponent as PlayerB1} from "../assets/images/bg_player_b1.svg"
import {ReactComponent as PlayerB2} from "../assets/images/bg_player_b2.svg"
import {ReactComponent as PlayerB3} from "../assets/images/bg_player_b3.svg"
import {ReactComponent as PlayerB4} from "../assets/images/bg_player_b4.svg"
import {ReactComponent as PlayerB5} from "../assets/images/bg_player_b5.svg"
import {ReactComponent as PlayerB6} from "../assets/images/bg_player_b6.svg"
import {ReactComponent as PlayerB7} from "../assets/images/bg_player_b7.svg"
import {ReactComponent as PlayerB8} from "../assets/images/bg_player_b8.svg"
import {ReactComponent as PlayerB9} from "../assets/images/bg_player_b9.svg"
import {ReactComponent as PlayerB10} from "../assets/images/bg_player_b10.svg"
import {ReactComponent as PlayerP1} from "../assets/images/bg_player_p1.svg"
import {ReactComponent as PlayerP2} from "../assets/images/bg_player_p2.svg"
import {ReactComponent as PlayerP3} from "../assets/images/bg_player_p3.svg"
import {ReactComponent as PlayerP4} from "../assets/images/bg_player_p4.svg"
import {ReactComponent as PlayerP5} from "../assets/images/bg_player_p5.svg"
import {ReactComponent as PlayerP6} from "../assets/images/bg_player_p6.svg"
import {ReactComponent as PlayerP7} from "../assets/images/bg_player_p7.svg"
import {ReactComponent as PlayerP8} from "../assets/images/bg_player_p8.svg"
import {ReactComponent as PlayerP9} from "../assets/images/bg_player_p9.svg"
import {ReactComponent as PlayerP10} from "../assets/images/bg_player_p10.svg"
import DoosanLogo from "../assets/images/doosan_logo.png"
import SamsungLogo from "../assets/images/samsung_logo.png"
import HanhwaLogo from "../assets/images/hanhwa_logo.png"
import KtLogo from "../assets/images/kt_logo.png"
import LotteLogo from "../assets/images/lotte_logo.png"
import LgLogo from "../assets/images/lg_logo.png"
import KiaLogo from "../assets/images/kia_logo.png"
import KiwoomLogo from "../assets/images/kiwoom_logo.png"
import NcLogo from "../assets/images/nc_logo.png"
import SsgLogo from "../assets/images/ssg_logo.png"
import BgFa from "../assets/images/bg_fa.svg"
import { calculatePlayerOvr } from "../utils/calculatePlayerOvr"
import { getTopImageByPlayerId } from "../api/getTopImagesByPlayerIds"
import { useImageCache } from "../contexts/ImageCacheContext"

const PlayerContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 6.25rem;
    height: 9.0625rem;
    border-radius: 0 0.625rem 0 0.625rem;
    position: relative;
    overflow: hidden;
    transform: scale(${props => props.$scale || 1});
    transform-origin: center;
`


const SignaturePlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #FFFDFF 0%,
        #FF45B2 100%
    );
    border: #FF45B2 solid 0.125rem;
`

const SeasonPlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #FFFFFF 0%,
        #BEBEBE 100%
    );
    border: #87898A solid 0.125rem;
`

const LivePlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #FFFFFF 0%,
        #BEBEBE 100%
    );
    border: #87898A solid 0.125rem;
`

const ImpactPlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #A7FF05 0%,
        #598606 100%
    );
    border: #598606 solid 0.125rem;
`

const GoldenGlovePlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #FFCD45 0%,
        #997100 100%
    );
    border: #997100 solid 0.125rem;
`

const AllStarPlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #428EFF 0%,
        #034AE2 100%
    );
    border: #034AE2 solid 0.125rem;
`

const InternationalPlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #FF4646 0%,
        #1A50FF 100%
    );
    border: #1A50FF solid 0.125rem;
`

const Live5Player = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #00FBFF 0%,
        #A600FF 100%
    );
    border: #8900D3 solid 0.125rem;
`

const Live4Player = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #FFF600 0%,
        #6B6B6B 100%
    );
    border: #6B6B6B solid 0.125rem;
`

const DummyPlayer = styled(PlayerContainer)`
    background-image: linear-gradient(
        -124deg,
        #000000 0%,
        #000000 100%
    );
    border: #000000 solid 0.125rem;
`

const StarImage = styled.img`
    position: absolute;
    top: 0rem;
    align-self: center;
    height: 1.125rem;
`

const OvrText = styled.div`
    position: absolute;
    top: 1.125rem;
    left: 0.225rem;
    font-family: 'Vitro Inspire';
    font-size: 1.5rem;
    color: white;
    text-shadow: 
    -0.0625rem -0.0625rem 0 #000,  
     0.0625rem -0.0625rem 0 #000,  
    -0.0625rem  0.0625rem 0 #000,  
     0.0625rem  0.0625rem 0 #000,
    -0.0625rem -0.0625rem 0.125rem #000,  
     0.0625rem -0.0625rem 0.125rem #000,  
    -0.0625rem  0.0625rem 0.125rem #000,  
     0.0625rem  0.0625rem 0.125rem #000;
`

const EnforceImage = styled.img`
    position: absolute;
    width: 1.5rem;
    top: 3.125rem;
    left: 0.225rem;

    filter: 
    drop-shadow(0.0625rem 0.0625rem 0.25rem rgba(255, 255, 255, 0.25));
`

const AwakenImage = styled.img`
    position: absolute;
    width: 2.125rem;
    top: 3rem;
    left: 0rem;

    filter: 
    drop-shadow(0.0625rem 0.0625rem 0.25rem rgba(255, 255, 255, 0.25));
`

const TeamPositionContainer = styled.div`
    position: absolute;
    top: 2.925rem;
    right: 0rem;
    width: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`

// const TeamText = styled.div`
//     font-family: 'Esamanru', sans-serif;
//     font-size: 0.875rem;
//     font-weight: 700;
//     color: white;
//     margin-bottom: 0.175rem;
//     text-shadow: 
//     -0.0625rem -0.0625rem 0 #000,  
//      0.0625rem -0.0625rem 0 #000,  
//     -0.0625rem  0.0625rem 0 #000,  
//      0.0625rem  0.0625rem 0 #000,
//     -0.0625rem -0.0625rem 0.125rem #000,  
//      0.0625rem -0.0625rem 0.125rem #000,  
//     -0.0625rem  0.0625rem 0.125rem #000,  
//      0.0625rem  0.0625rem 0.125rem #000;
// `

const PositionText = styled.div`
    /* position: absolute;
    top: 2.925rem;
    right: 0.125rem; */
    font-family: 'Esamanru', sans-serif;
    font-size: 0.9625rem;
    font-weight: 600;
    color: white;
    text-shadow: 
    -0.0625rem -0.0625rem 0 #000,  
     0.0625rem -0.0625rem 0 #000,  
    -0.0625rem  0.0625rem 0 #000,  
     0.0625rem  0.0625rem 0 #000,
    -0.0625rem -0.0625rem 0.125rem #000,  
     0.0625rem -0.0625rem 0.125rem #000,  
    -0.0625rem  0.0625rem 0.125rem #000,  
     0.0625rem  0.0625rem 0.125rem #000;
`

const PlayerNameText = styled.div`
    position: absolute;
    bottom: 0.125rem;
    align-self: center;
    font-family: 'Esamanru', sans-serif;
    font-weight: 500;
    font-size: 0.9625rem;
    color: white;
    z-index: 2;
    text-shadow:
    -0.0625rem -0.0625rem 0 #000,
     0.0625rem -0.0625rem 0 #000,
    -0.0625rem  0.0625rem 0 #000,
     0.0625rem  0.0625rem 0 #000,
    -0.0625rem -0.0625rem 0.125rem #000,
     0.0625rem -0.0625rem 0.125rem #000,
    -0.0625rem  0.0625rem 0.125rem #000,
     0.0625rem  0.0625rem 0.125rem #000;
`

const DescriptionText = styled.div`
    position: absolute;
    bottom: 1.225rem;
    align-self: center;
    font-family: 'Pretendard Variable';
    font-weight: 600;
    font-size: 0.75rem;
    color: white;
    z-index: 2;
    text-shadow:
    -0.0625rem -0.0625rem 0 #000,
     0.0625rem -0.0625rem 0 #000,
    -0.0625rem  0.0625rem 0 #000,
     0.0625rem  0.0625rem 0 #000,
    -0.0625rem -0.0625rem 0.125rem #000,
     0.0625rem -0.0625rem 0.125rem #000,
    -0.0625rem  0.0625rem 0.125rem #000,
     0.0625rem  0.0625rem 0.125rem #000;
`

const PlayerImage = styled.img`
    position: absolute;
    align-self: center;
    justify-self: center;
    width: 100%;
    border-radius: 0 0.625rem 0 0.625rem; 
`

const FaImage = styled.img`
    position: absolute;
    top: 2rem;
    right: 0rem;
    width: 1.825rem;
`

const TeamLogoImage = styled.img`
    position: absolute;
    top: 1.125rem;
    right: 0.125rem;
    width: 1.625rem;
`

const SvgWrapper = styled.div`
    position: absolute;
    align-self: center;
    justify-self: center;
    width: 100%;
    height: 100%;
    border-radius: 0 0.625rem 0 0.625rem; 
    
    // FullAwakenPlayerImage의 필터 스타일을 CSS로 적용
    filter: ${(props) => 
        props.$isAwaken && props.$level === 9
            ? `drop-shadow(0rem 0rem 0.25rem rgba(255, 255, 255, 1))
               drop-shadow(0rem 0rem 0.375rem rgba(0, 238, 255, 1))`
            : `drop-shadow(0rem 0rem 0.25rem rgba(0, 0, 0, 0.5))`
    };
`;

const CustomPlayerImage = styled.img`
    position: absolute;
    bottom: 0;           /* 하단 밀착 */
    left: 50%;           /* 중앙 시작 */
    transform: translateX(-50%); /* 정확한 중앙 정렬 */
    width: auto;         /* 가로를 카드에 맞춤 */
    height: 100%;        /* 비율 유지 */
    max-height: 100%;    /* 카드를 넘지 않게 */
    object-fit: contain;
    z-index: 0;          /* 텍스트/로고보다는 뒤에 위치 */
`;

const GradientOverlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: ${(props) => {
        const color = props.$color || '#000000';
        // 16진수를 RGB로 변환
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        return `linear-gradient(to top, rgba(${r}, ${g}, ${b}, 1) 0%, rgba(${r}, ${g}, ${b}, 0) 50%)`;
    }};
    pointer-events: none;
    z-index: 1;
`;

const StarMap = {
    5: Star5,
    4: Star4,
    3: Star3,
    2: Star2,
    1: Star1,
}

const EnforceMap = {
    0: Enforce0,
    1: Enforce1,
    2: Enforce2,
    3: Enforce3,
    4: Enforce4,
    5: Enforce5,
    6: Enforce6,
    7: Enforce7,
    8: Enforce8,
    9: Enforce9,
    10: Enforce10,
}

const AwakenMap = {
    1: Awaken1,
    2: Awaken2,
    3: Awaken3,
    4: Awaken4,
    5: Awaken5,
    6: Awaken6,
    7: Awaken7,
    8: Awaken8,
    9: Awaken9,
}

const TeamLogoMap = {
    '두산' : DoosanLogo,
    '삼성' : SamsungLogo,
    '롯데' : LotteLogo,
    'LG' : LgLogo,
    'KIA' : KiaLogo,
    '키움' : KiwoomLogo,
    'NC' : NcLogo,
    'SSG' : SsgLogo,
    '한화' : HanhwaLogo,
    'KT' : KtLogo,
}

const PlayerTypeMap = {
    '시즌' : SeasonPlayer,
    '라이브': LivePlayer,
    '시그니쳐' : SignaturePlayer,
    '임팩트' : ImpactPlayer,
    '골든글러브': GoldenGlovePlayer,
    '올스타': AllStarPlayer,
    '국가대표': InternationalPlayer,
    "더미" : DummyPlayer
}

const GradientColorMap = {
    '시즌': '#87898A',
    '라이브': '#87898A',
    '시그니쳐': '#FF45B2',
    '임팩트': '#598606',
    '골든글러브': '#997100',
    '올스타': '#034AE2',
    '국가대표': '#1A50FF',
    '더미': '#000000',
}

const LiveGradientColorMap = {
    5: '#8900D3',
    4: '#6B6B6B',
    3: '#87898A',
}

const LivePlayerTypeMap = {
    5: Live5Player,
    4: Live4Player,
    3: LivePlayer,
}

const BatterPlayerImageMap = {
    1: PlayerB1,
    2: PlayerB2,
    3: PlayerB3,
    4: PlayerB4,
    5: PlayerB5,
    6: PlayerB6,
    7: PlayerB7,
    8: PlayerB8,
    9: PlayerB9,
    10: PlayerB10,
}

const PitcherPlayerImageMap = {
    1: PlayerP1,
    2: PlayerP2,
    3: PlayerP3,
    4: PlayerP4,
    5: PlayerP5,
    6: PlayerP6,
    7: PlayerP7,
    8: PlayerP8,
    9: PlayerP9,
    10: PlayerP10,
}

const PlayerImageGradientMap = {
    '두산': {
        start: '#1A1748',
        end: '#000000',
    },
    '삼성': {
        start: '#074CA1',
        end: '#000000',
    },
    'KIA': {
        start: '#EA0029',
        end: '#000000',
    },
    '롯데': {
        start: '#041E42',
        end: '#000000',
    },
    '키움': {
        start: '#570514',
        end: '#000000',
    },
    'LG': {
        start: '#C30452',
        end: '#000000',
    },
    'NC': {
        start: '#315288',
        end: '#000000',
    },
    '한화': {
        start: '#FC4E00',
        end: '#000000',
    },
    'KT': {
        start: '#666666',
        end: '#000000',
    },
    'SSG': {
        start: '#C91433',
        end: '#000000',
    },
    '더미': {
        start: '#999999',
        end: '#282828',
    },
}

// player
// id, originalOvr, year?, stars, playerName, description?, team, position, type, isPitcher
// hittingAngle?, setDeckScore, originalStates, trainedStates, speacialTrainedStates, postionTrainedStates, level, isAwaken
// states : level, s1, s2, s3, s4, s5, s6

export default function PlayerCard({player, isForDisplay, onClick, initialFaceOn, scale = 1, cachedImageUrl, onImageLoaded}) {
    const [fetchedImageUrl, setFetchedImageUrl] = useState(null);
    const { getFromCache, addToCache } = useImageCache();

    useEffect(() => {
        const loadImage = async () => {
            // initialFaceOn이 있으면 fetchedImageUrl을 설정하지 않음
            if (initialFaceOn) {
                return;
            }

            // props로 전달된 캐시에 있으면 그걸 사용
            if (cachedImageUrl) {
                setFetchedImageUrl(cachedImageUrl);
                return;
            }

            // player.faceOn.id가 없으면 API로 이미지 로드
            if ((!player.faceOn || !player.faceOn.id) && player.playerName) {
                const playerId = `${player.playerName}-${player.team}`;
                // 전역 캐시 확인
                const globalCachedUrl = getFromCache(playerId);
                if (globalCachedUrl) {
                    setFetchedImageUrl(globalCachedUrl);
                    return;
                }

                // API로 이미지 로드
                const imageData = await getTopImageByPlayerId(playerId);
                if (imageData && imageData.image_url) {
                    setFetchedImageUrl(imageData.image_url);
                    // 전역 캐시에 저장
                    addToCache(playerId, imageData.image_url);
                    // props 콜백 실행
                    if (onImageLoaded) {
                        onImageLoaded(player.playerName, imageData.image_url);
                    }
                }
            }
        };

        loadImage();
    }, [player.playerName, player.team, initialFaceOn, cachedImageUrl, onImageLoaded, getFromCache, addToCache]);

    const gradientData = PlayerImageGradientMap[player.team] || PlayerImageGradientMap['KT'];
    const gradientId = `team-gradient-${player.team}`;

    const displayedName = player.playerName + (player.year != null ? ('\''+player.year) : "")

    let SelectedPlayerContainer = PlayerTypeMap[player.type] || ImpactPlayer;
    SelectedPlayerContainer = player.type === '라이브' ? LivePlayerTypeMap[player.stars] || LivePlayer : SelectedPlayerContainer;

    const DefaultSvgImage = player.isPitcher ?
        (PitcherPlayerImageMap[(koreanNameHash(player.playerName) % 10) + 1] || PlayerP1)
        :
        (BatterPlayerImageMap[(koreanNameHash(player.playerName) % 10) + 1] || PlayerB1)

    const playerOvr = isForDisplay ? player.originalOvr : calculatePlayerOvr(player);

    const currentFaceOn = player.faceOn || null
    const hasFaceOn = currentFaceOn && currentFaceOn.id
    const teamImage = player.isFa ? TeamLogoMap[player.isFa] || DoosanLogo : TeamLogoMap[player.team] || DoosanLogo 

    return (
        <SelectedPlayerContainer onClick={onClick} $scale={scale}>

            <svg width="0" height="0" style={{ position: 'absolute' }}>
                <defs>
                    <linearGradient id={gradientId} x1="50%" y1="0%" x2="50%" y2="100%">
                        <stop offset="0%" style={{ stopColor: gradientData.start, stopOpacity: 1 }} />
                        <stop offset="100%" style={{ stopColor: gradientData.end, stopOpacity: 1 }} />
                    </linearGradient>
                </defs>
            </svg>

            <SvgWrapper $isAwaken={player.isAwaken} $level={player.level}>
                {initialFaceOn ? (
                    // 초기 이미지 (preview 용)가 있으면 최우선으로 출력
                    <CustomPlayerImage src={initialFaceOn} alt={player.playerName} />
                ) : hasFaceOn ? (
                    // 사용자가 선택한 커스텀 이미지가 있으면 img 태그로 출력
                    <CustomPlayerImage src={player.faceOn.url} alt={player.playerName} />
                ) : fetchedImageUrl ? (
                    // 또는 API로부터 가져온 이미지가 있으면 그걸 출력
                    <CustomPlayerImage src={fetchedImageUrl} alt={player.playerName} />
                ) : (
                    // 없으면 기존처럼 해시 기반 기본 SVG 출력
                    DefaultSvgImage && (
                        <DefaultSvgImage
                            style={{ width: '100%', height: '100%' }}
                            fill={`url(#${gradientId})`}
                        />
                    )
                )}
            </SvgWrapper>

            <GradientOverlay $color={player.type === '라이브' ? LiveGradientColorMap[player.stars] : GradientColorMap[player.type]} />

            { player.team !== "더미" ? <StarImage src={StarMap[player.stars]}/> : null }

            { player.team !== "더미" ? <OvrText>{playerOvr}</OvrText> : null }
            
            {player.team !== "더미" ?
                !isForDisplay ? (player.isAwaken? 
                    <AwakenImage src={AwakenMap[player.level]}></AwakenImage> 
                    :
                    <EnforceImage src={EnforceMap[player.level]}></EnforceImage>
                )
                    : null
                
                : null
            }

            { player.team !== "더미" ? <TeamLogoImage src={teamImage}/> : null }

            <TeamPositionContainer>
                <PositionText>{player.position}</PositionText>
            </TeamPositionContainer>

            {player.isFa && <FaImage src={BgFa}/>}

            <PlayerNameText>{displayedName}</PlayerNameText>
            <DescriptionText>{player.description}</DescriptionText>

        </SelectedPlayerContainer>
    )
}

function koreanNameHash(name) {
    let hashCode = 5381; 
    
    const encoder = new TextEncoder();
    const nameBytes = encoder.encode(name); 

    for (const byte of nameBytes) {
        hashCode = ((hashCode << 5) + hashCode) + byte;
        hashCode = hashCode >>> 0;
    }
    
    return hashCode;
}